import React, { useEffect, useState, useMemo } from 'react';
import buttonAudio from 'assets/sounds/press_button.mp3';
import spinStartAudio from 'assets/sounds/spin_start.mp3';
import spinAudio from 'assets/sounds/spin.mp3';
import spinStopAudio from 'assets/sounds/spin_stop.mp3';
import winAudio from 'assets/sounds/win.mp3';
import { useNavigate } from 'react-router-dom';
import { connect, clearCache } from '../redux/blockchain/blockchainActions'
import { useDispatch, useSelector } from 'react-redux';
import slotAbi from "../contracts/slotAbi.json";
import ercAbi from "../contracts/ERC20.json";
import Loader from 'Loader';
import Web3 from 'web3';
import ShowMessage from 'ShowMessage';
import TransitionModal from 'TransitionModal';

const Game = () => {
	const dispatch = useDispatch()
	const [spin, setSpin] = useState(false);
	const [ring1, setRing1] = useState();
	const [ring2, setRing2] = useState();
	const [ring3, setRing3] = useState();
	const [price, setPrice] = useState();
	const [input, setInput] = useState(10);
	const [jackpot, setJackpot] = useState(0);
	const [balance, setBalance] = useState(100000);
	const [isMute, setIsMute] = useState(false);
	const [totalSpins, setTotalSpins] = useState("0")
	const [spinsLeft, setSpinsLeft] = useState(10);
	const [winningAmount, setWinningAmount] = useState("0");
	const [message, setMessage] = useState('letsgo!');
	const [message1, setMessage1] = useState('');
	const [showMessge, setShowMessge] = useState(true);
	const [modal, setModal] = useState(false)
	const [purchaseAmount, setpurchaseAmount] = useState("0")
	const [walletBalance, setwalletBalance] = useState("0")
	const [rendomReward, setRendomReward] = useState(false)
	const [tokenBalances, setTokenBalance] = useState("0")
	const [closePopUp, setClosePopUp] = useState(true)
	const [loading, setLoading] = useState(false)
	const [hideData, setHideData] = useState(false)
	const [open, setOpen] = useState(false);
	const [progress, setProgress] = useState(0);
	const[isShowTransitionModal,setIsShowTransitionModal]=useState(false)
	const blockchain = useSelector((state) => state.blockchain);
	// console.log("hideData>>>>>>>>", hideData)
	console.log("blockchain>>>>>>>>>>>>>>>>>>", blockchain)
	const navigate = useNavigate();

	const buttonClickAudio = useMemo(() => new Audio(buttonAudio), []);
	const spinningStartAudio = useMemo(() => new Audio(spinStartAudio), []);
	const spinningAudio = useMemo(() => new Audio(spinAudio), []);
	const spinningStopAudio = useMemo(() => new Audio(spinStopAudio), []);
	const winningAudio = useMemo(() => new Audio(winAudio), []);

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const onClickPopClose = () => {
		setClosePopUp(x => !x)
	}

	const setmodals = () => {
		if (modal) {
			setModal(false)
		}
	}

	const contractAddress = "0x93d26cAf3E18a417b94Ddd77562266D4C4149090"
	const tokenContractAddress = "0x9D9957cefE34948c13bE9a19f4Fdd7A23eB51EEe"
	const web3 = new Web3(new Web3.providers.HttpProvider("https://rpc-mumbai.maticvigil.com/"));
	const myContract = new web3.eth.Contract(slotAbi, contractAddress)

	const tokenBalance = async () => {
		const tokenContract = new blockchain.web3.eth.Contract(ercAbi, tokenContractAddress)
		let balance = await tokenContract.methods.balanceOf(blockchain.account).call()
		balance = blockchain.web3.utils.fromWei(balance.toString());
		setTokenBalance(balance.toString())
	}

	const deposit = async (amount) => {
		const slotContract = new blockchain.web3.eth.Contract(slotAbi, contractAddress)
		console.log("slotcontract===>", slotContract);
		console.log("amount===>",amount);
		console.log("blockchain.web3.utils.toWei(amount.toString())===>",blockchain.web3.utils.toWei(amount.toString()));
		await slotContract.methods.userDeposit().send({
			from: blockchain.account,
			value: blockchain.web3.utils.toWei(amount.toString())

		})
			.once("error", (err) => {
				setLoading(false);
				setModal(false)
			})
			.then(async (receipt) => {
				setLoading(false);
				setModal(false)
			});
	}

	const claim = async () => {
		console.log("blockchain=======", blockchain.web3);
		const slotContract = new blockchain.web3.eth.Contract(slotAbi, contractAddress)


		console.log("slotcontract===>", slotContract);
		await slotContract.methods.claimWinningAmount().send({
			from: blockchain.account

		})
			.once("error", (err) => {

				console.log("err=109===>", err);
			})
			.then(async (receipt) => {


				console.log("ttttt==114===>", receipt);
			});
	}

	const userInfo = async () => {
		try {
			if (blockchain.account !== null) {

				const slotContract = new blockchain.web3.eth.Contract(slotAbi, contractAddress)

				console.log("slotcontract111111===>", slotContract);
				let data = await slotContract.methods._userInfo(blockchain.account).call();
				let totaljackpot = await slotContract.methods.totaljackpot().call();
				totaljackpot = blockchain.web3.utils.fromWei(totaljackpot.toString())
				let walletbalance = await blockchain.web3.eth.getBalance(blockchain.account)
				walletbalance = blockchain.web3.utils.fromWei(walletbalance)
				data.winningAmount = blockchain.web3.utils.fromWei(data.winningAmount.toString())
				console.log("=user ==datat==>", data);
				setWinningAmount(data.winningAmount)
				setTotalSpins(data.spins)
				setJackpot(totaljackpot.toString())
				setwalletBalance((walletbalance.toString()))
				tokenBalance()
			}
		} catch (error) {
			console.log("error ", error);
		}
	}

	const rendomWords = async () => {
		try {
			if (Number(totalSpins) === 0) {
				setShowMessge(false);
				setRendomReward(false)
				setMessage("🥶 Purchase more spins.")
			} else {
				handleOpen()
				setProgress(10)
				setProgress(20)
				const gasPrice = await web3.eth.getGasPrice()
				const Data = await myContract.methods.requestRandomWords(blockchain.account).encodeABI();
				const gasLimit = await web3.eth.estimateGas({
					from: "0x27d5D89b4Ea2b092d1a49A3B8883E61528383D9B",
					to: contractAddress,
					data: Data  // Setting the pid 12 with 0 alloc and 0 deposit fee`
				});
				setProgress(30)
				setProgress(40)
				let fee = gasLimit * gasPrice;
				let txFee = Number(web3.utils.fromWei(fee.toString(), "ether"));
				const rawTransaction = {
					to: contractAddress,
					gasPrice: web3.utils.toHex(gasPrice),    // Always in Wei (30 gwei)
					gasLimit: web3.utils.toHex(gasLimit),      // Always in Wei
					data: Data  // Setting the pid 12 with 0 alloc and 0 deposit fee
				};

				const signPromise = await web3.eth.accounts.signTransaction(rawTransaction, '1b0cd97190de473e1af0017afe3efb38e9e77634b378c331dab05f91104f8f4d');

				setProgress(50)
				setProgress(60)
				web3.eth.sendSignedTransaction(signPromise.rawTransaction, function (
					error, hash
				) {
					if (!error) {
						let i = 0;
						setProgress(70)
						setProgress(80)
						const interval = setInterval(function () {
							web3.eth.getTransactionReceipt(hash, async function (err, rec) {
								if (rec) {
									console.log(rec);
									setProgress(90)
									clearInterval(interval);
									setRendomReward(false)
									userInfo()
						            setProgress(100)
									handleClose()
									spinHandler()
									console.log("rendomWords", rec);
									//   })
								}
							});
						}, 1000);
					} else {
						console.log(
							"Something went wrong while submitting your transaction:",
							error
						)
					};
				})

			}
		} catch (error) {
			console.log(error);

		}

	}

	const rendomWords_spk = async () => {

		try {
			const slotContract = new blockchain.web3.eth.Contract(slotAbi, contractAddress)

			console.log("slotcontract111111===>", slotContract);
			let rendomwords = await slotContract.methods.requestRandomWords(blockchain.account).send({
				from: blockchain.account
			})
				.once("error", (err) => {
					// setLoading(true);

					// random = setInterval(fetchRandom(), 5000)
					spinHandler()
					// console.log("random>>>>", random)
					// console.log("dddddd", err);
					console.log("hey I am rejected", err)
				})
				.then(async (receipt) => {
					// setLoading(true);

					// random = setInterval(fetchRandom(), 5000)
					spinHandler()
					console.log("ttttt", receipt);

					// dispatch(fetchData(blockchain.account));

				});
		}
		catch (err) {
			console.log(err);
		}

	}

	const fetchRandom = async () => {
		try {
			const slotContract = new blockchain.web3.eth.Contract(slotAbi, contractAddress)
			setMessage("loding")
			setMessage1("....")
			let fetchrandom = await slotContract.methods.getRequestStatusbyUSerAddress(blockchain.account).call();
			console.log("fetchrandom", fetchrandom)

			if (fetchrandom.fulfilled) {

				setRing1(Number(fetchrandom.randomWords[0]))
				setTimeout(function () { setRing2(Number(fetchrandom.randomWords[1])) }, 1000)
				setTimeout(function () {
					setRing3(Number(fetchrandom.randomWords[2]));
				}, 2000)

				setTimeout(function () {
					premio()
				}, 4000)

			} else {
				fetchRandom()
			}
		} catch (error) {
			fetchRandom()
		}
	}


	const calculateReward = async () => {
		try {
			const gasPrice = await web3.eth.getGasPrice()
			console.log("gasPrice==", gasPrice);
			const Data = await myContract.methods.calculateReward(blockchain.account).encodeABI();
			console.log("Data==", Data);
			const gasLimit = await web3.eth.estimateGas({
				from: "0x27d5D89b4Ea2b092d1a49A3B8883E61528383D9B",
				to: contractAddress,
				data: Data  // Setting the pid 12 with 0 alloc and 0 deposit fee`
			});
			let fee = gasLimit * gasPrice;
			let txFee = Number(web3.utils.fromWei(fee.toString(), "ether"));			
			const rawTransaction = {
				to: contractAddress,
				gasPrice: web3.utils.toHex(gasPrice),    // Always in Wei (30 gwei)
				gasLimit: web3.utils.toHex(gasLimit),      // Always in Wei
				data: Data  // Setting the pid 12 with 0 alloc and 0 deposit fee
			};

			const signPromise = await web3.eth.accounts.signTransaction(rawTransaction, '1b0cd97190de473e1af0017afe3efb38e9e77634b378c331dab05f91104f8f4d');
			console.log("signPromise====>", signPromise);

			web3.eth.sendSignedTransaction(signPromise.rawTransaction)
				.once("error", (err) => {
					setRendomReward(false)
					console.log("hey I am rejected", err)
				})
				.then(async (receipt) => {
					setRendomReward(false)
					console.log("ttttt", receipt);

				});
		} catch (err) {
			console.log(err);
		}

	}

	useEffect(() => {
		userInfo()

	}, [blockchain.account])

	useEffect(() => {
		if (isMute) {
			buttonClickAudio.volume = 0;
			spinningStartAudio.volume = 0;
			spinningAudio.volume = 0;
			spinningStopAudio.volume = 0;
			winningAudio.volume = 0;
		} else {
			buttonClickAudio.volume = 1;
			spinningStartAudio.volume = 1;
			spinningAudio.volume = 1;
			spinningStopAudio.volume = 1;
			winningAudio.volume = 1;
		}

	}, [isMute, buttonClickAudio, spinningStartAudio, spinningAudio, spinningStopAudio, winningAudio]);

	useEffect(() => {
		win()
	}, [ring3 !== undefined]);


	const row1 = () => {
		if (!spin) {
			return (
				<>
					<div className="ringEnd"></div>
					<div className="ringEnd"> ▶️ </div>
				</>
			)
		} else if (spin && ring1 === undefined) {
			return (
				<>

					<div className="ringMoving">🏆</div>
					<div className="ringMoving">💲</div>
					<div className="ringMoving">🔥</div>
					<div className="ringMoving">🧨</div>
					<div className="ringMoving">🎯</div>
					<div className="ringMoving">🎰</div>
					<div className="ringMoving">🪙</div>
					<div className="ringMoving">🤑</div>
					<div className="ringMoving">💩</div>
				</>
			)
		} else if (ring1 == 1) {
			return (
				<>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
				</>
			)
		} else if (ring1 == 2) {
			return (
				<>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
				</>
			)
		} else if (ring1 == 3) {
			return (
				<>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
				</>
			)
		} else if (ring1 == 4) {
			return (
				<>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
				</>
			)
		} else if (ring1 == 5) {
			return (
				<>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
				</>
			)
		} else if (ring1 == 6) {
			return (
				<>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
				</>
			)
		} else if (ring1 == 7) {
			return (
				<>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
				</>
			)
		} else if (ring1 == 8) {
			return (
				<>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
				</>
			)
		} else if (ring1 == 9) {
			return (
				<>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
				</>
			)
		}
	}

	const row2 = () => {
		if (!spin) {
			return (
				<>
					<div className="ringEnd"></div>
					<div className="ringEnd"> ▶️ </div>
				</>
			)
		} else if (spin && ring2 === undefined) {
			return (
				<>

					<div className="ringMoving">🏆</div>
					<div className="ringMoving">💲</div>
					<div className="ringMoving">🔥</div>
					<div className="ringMoving">🧨</div>
					<div className="ringMoving">🎯</div>
					<div className="ringMoving">🎰</div>
					<div className="ringMoving">🪙</div>
					<div className="ringMoving">🤑</div>
					<div className="ringMoving">💩</div>
				</>
			)
		} else if (ring2 == 1) {
			return (
				<>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
				</>
			)
		} else if (ring2 == 2) {
			return (
				<>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
				</>
			)
		} else if (ring2 == 3) {
			return (
				<>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
				</>
			)
		} else if (ring2 == 4) {
			return (
				<>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
				</>
			)
		} else if (ring2 == 5) {
			return (
				<>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
				</>
			)
		} else if (ring2 == 6) {
			return (
				<>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
				</>
			)
		} else if (ring2 == 7) {
			return (
				<>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
				</>
			)
		} else if (ring2 == 8) {
			return (
				<>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
				</>
			)
		} else if (ring2 == 9) {
			return (
				<>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
				</>
			)
		}
	}

	const row3 = () => {
		if (!spin) {
			return (
				<>
					<div className="ringEnd"></div>
					<div className="ringEnd"> ▶️ </div>
				</>
			)
		} else if (spin && ring3 === undefined) {
			return (
				<>
					<div className="ringMoving">🏆</div>
					<div className="ringMoving">💲</div>
					<div className="ringMoving">🔥</div>
					<div className="ringMoving">🧨</div>
					<div className="ringMoving">🎯</div>
					<div className="ringMoving">🎰</div>
					<div className="ringMoving">🪙</div>
					<div className="ringMoving">🤑</div>
					<div className="ringMoving">💩</div>
				</>
			)
		} else if (ring3 == 1) {
			return (
				<>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
				</>
			)
		} else if (ring3 == 2) {
			return (
				<>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
				</>
			)
		} else if (ring3 == 3) {
			return (
				<>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
				</>
			)
		} else if (ring3 == 4) {
			return (
				<>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
				</>
			)
		} else if (ring3 == 5) {
			return (
				<>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
				</>
			)
		} else if (ring3 == 6) {
			return (
				<>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
				</>
			)
		} else if (ring3 == 7) {
			return (
				<>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
				</>
			)
		} else if (ring3 == 8) {
			return (
				<>
					<div className="ringEnd">🪙</div>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
				</>
			)
		} else if (ring3 == 9) {
			return (
				<>
					<div className="ringEnd">🤑</div>
					<div className="ringEnd">💩</div>
					<div className="ringEnd">🏆</div>
					<div className="ringEnd">💲</div>
					<div className="ringEnd">🔥</div>
					<div className="ringEnd">🧨</div>
					<div className="ringEnd">🎯</div>
					<div className="ringEnd">🎰</div>
					<div className="ringEnd">🪙</div>
				</>
			)
		}
	}

	const rand = () => {
		setRing1(Math.floor(Math.random() * (100 - 1) + 1))
		setTimeout(function () { setRing2(Math.floor(Math.random() * (100 - 1) + 1)) }, 1000)
		setTimeout(function () {
			setRing3(Math.floor(Math.random() * (100 - 1) + 1));
		}, 2000)
	}

	const play = () => {
		buttonClickAudio.play();
		if (ring3 > 1 || !spin) {
			if (input <= balance && input >= 1 || 1 == 1) {
				spinningStartAudio.play();
				spinningAudio.addEventListener('ended', function () {
					this.currentTime = 1000;
					this.play();
				}, false);
				spinningAudio.play();
				setSpin(true)
				setRing1()
				setRing2()
				setRing3()
				setTimeout(function () {
					fetchRandom();
				}, 15000);
				//we can increase time to set spin time(above)
				setTimeout(() => {
					spinningAudio.pause();
					spinningAudio.currentTime = 0;
					spinningStopAudio.play();
					if (totalSpins > 0) {
						setSpinsLeft(prev => prev - 1)
					}
				}, 30000)
			} else {
				setPrice(10)
			}
		}
	}


	const win = () => {
		let i = ring1
		let j = ring2
		let k = ring3
		if (i == 1 && j == 1 && k == 1) {
			winningAudio.play();
			setMessage("jackpotWin")
			setMessage1("80% of JackpotAmount")

		} else if ((i == 1 && j == 1) || (i == 1 && k == 1) || (j == 1 && k == 1)) {
			winningAudio.play();

			setMessage("winning")
			setMessage1("20% of JackpotAmount")

		} else if (i == 2 && j == 2 && k == 2) {

			winningAudio.play();
			setMessage("winning")
			setMessage1("10% of JackpotAmount")

		} else if ((i == 2 && j == 2) || (i == 2 && k == 2) || (j == 2 && k == 2)) {

			winningAudio.play();
			setMessage("winning")
			setMessage1("5% of JackpotAmount")
		} else if (i == 3 && j == 3 && k == 3) {
			setMessage("Better luck next time")
			setMessage1("better luck next time")

		} else if ((i == 3 && j == 3) || (i == 3 && k == 3) || (j == 3 && k == 3)) {
			setMessage("Better luck next time")
			setMessage1("better luck next time")
		} else if (i == 4 && j == 4 && k == 4) {
			setMessage("Better luck next time")
			setMessage1("better luck next time")


		} else if ((i == 4 && j == 4) || (i == 4 && k == 4) || (j == 4 && k == 4)) {
			setMessage("better luck next time")
			setMessage1("better luck next time")
		} else if (i == 5 && j == 5 && k == 5) {
			winningAudio.play();

			setMessage("you've win Spins")
			setMessage1("5 spins")

		} else if ((i == 5 && j == 5) || (i == 5 && k == 5) || (j == 5 && k == 5)) {

			winningAudio.play();
			setMessage("you've win Spins")
			setMessage1("2 spins")
		} else if (i == 6 && j == 6 && k == 6) {
			winningAudio.play();

			setMessage("you've win Spins")
			setMessage1("10 spins")

		} else if ((i == 6 && j == 6) || (i == 6 && k == 6) || (j == 6 && k == 6)) {

			winningAudio.play();
			setMessage("you've win Spins")
			setMessage1("4 spins")

		} else if (i == 7 && j == 7 && k == 7) {

			winningAudio.play();
			setMessage("you've win token")
			setMessage1("5000 tokens")


		} else if ((i == 7 && j == 7) || (i == 7 && k == 7) || (j == 7 && k == 7)) {

			winningAudio.play();
			setMessage("you've win token")
			setMessage1("2000 tokens")


		} else if (i == 8 && j == 8 && k == 8) {
			winningAudio.play();
			setMessage("you've win token")
			setMessage1("10000 tokens")

		} else if ((i == 8 && j == 8) || (i == 8 && k == 8) || (j == 8 && k == 8)) {

			winningAudio.play();
			setMessage("you've win token")
			setMessage1("4000 tokens")

		} else if (i == 9 && j == 9 && k == 9) {
			setMessage("Better luck next time")
			setMessage1("better luck next time")
		} else if ((i == 9 && j == 9) || (i == 9 && k == 9) || (j == 9 && k == 9)) {
			setMessage("Better luck next time")
			setMessage1("better luck next time")
		} else if (i == undefined && j == undefined && k == undefined) {
			setMessage("Let's play the Game")
			setMessage1()


		} else {
			setMessage("Better luck next time")
			setMessage1()
		}
	}

	const premio = () => {
		let i = (ring1)
		let j = ring2
		let k = ring3
		if (i == 1 && j == 1 && k == 1) {
			calculateReward()

		} else if ((i == 1 && j == 1) || (i == 1 && k == 1) || (j == 1 && k == 1)) {
			calculateReward()

		} else if (i == 2 && j == 2 && k == 2) {

			calculateReward()

		} else if ((i == 2 && j == 2) || (i == 2 && k == 2) || (j == 2 && k == 2)) {

			calculateReward()

		} else if (i == 3 && j == 3 && k == 3) {

			calculateReward()

		} else if ((i == 3 && j == 3) || (i == 3 && k == 3) || (j == 3 && k == 3)) {

			calculateReward()

		} else if (i == 4 && j == 4 && k == 4) {

			calculateReward()

		} else if ((i == 4 && j == 4) || (i == 4 && k == 4) || (j == 4 && k == 4)) {

			calculateReward()

		} else if (i == 5 && j == 5 && k == 5) {

			calculateReward()

		} else if ((i == 5 && j == 5) || (i == 5 && k == 5) || (j == 5 && k == 5)) {

			calculateReward()

		} else if (i == 6 && j == 6 && k == 6) {
			calculateReward()

		} else if ((i == 6 && j == 6) || (i == 6 && k == 6) || (j == 6 && k == 6)) {

			calculateReward()

		} else if (i == 7 && j == 7 && k == 7) {

			calculateReward()

		} else if ((i == 7 && j == 7) || (i == 7 && k == 7) || (j == 7 && k == 7)) {

			calculateReward()

		} else if (i == 8 && j == 8 && k == 8) {
			calculateReward()

		} else if ((i == 8 && j == 8) || (i == 8 && k == 8) || (j == 8 && k == 8)) {

			calculateReward()


		} else if (i == 9 && j == 9 && k == 9) {
			
			setMessage("Better luck next time")
			setMessage1("better luck next time")

		} else if ((i == 9 && j == 9) || (i == 9 && k == 9) || (j == 9 && k == 9)) {

			setMessage("Better luck next time")
			setMessage1("better luck next time")

		} else if (i == undefined && j == undefined && k == undefined) {

			setMessage("Let's play the Game")
			setMessage1()

		} else {
			setMessage("Better luck next time")
			setMessage1()
		}
	}

	const navigateInfoHandler = () => {
		buttonClickAudio.play();
		navigate('/info')
	}

	const purchaseHandler = () => {
		buttonClickAudio.play();
	}

	const muteHandler = () => {
		setIsMute(prev => !prev);
	}

	const spinHandler = () => {
		if (Number(totalSpins) !== 0) {
			play();
		} else if (ring3 !== undefined) {
			setShowMessge(false);
			setMessage("🥶 Purchase more spins.")
			setMessage1()
		}
	}

	const inputChangeHandler = e => {
		setpurchaseAmount(e.target.value)
	}
	const resetButton = async () => {
		setSpin(false);
		userInfo()
		setMessage("Let's play the Game")
		setMessage1()
	}

	return (
		<>
			<div className="game-page">
				<div className="container">
					<div className="action-btns">
					<button className='claim-btn' onClick={(e) => {
							// e.preventDefault();
							if (blockchain.web3 !== null) {

								claim()
							}
						}}>Claim</button>
						<button className='reset-btn' onClick={(e) => {
							// e.preventDefault();
							resetButton()
						}}>Reset</button>
						<div className='info-btn-wrap'>
							<button className='info-btn' onClick={navigateInfoHandler}></button>
							<button className={`mute-btn ${isMute ? 'muted' : ''}`} onClick={muteHandler}></button>
							<button className='close-btn'></button>
						</div>
					</div>
					<div className="game-note-head-wrap">
						<div className='inner-text'>
							<div className='text'>Token Balance :</div>{tokenBalances} Token
						</div>
						<div className='inner-text'>
							<div className='text'>Wallet Balance :</div>{Number(walletBalance).toFixed(2)} Matic
						</div>
						<div className='inner-text'>
							<div className='text'>Winning Amount :</div>{Number(winningAmount).toFixed(2)} Matic
						</div>

					</div>
					{blockchain.account == null ? (
						<button
							className='game-btn-wrap-head'
							onClick={async (e) => {
								e.preventDefault();
								let data = await dispatch(connect());
								if (data === false) {
									setHideData(true)
								}
							}}
						>
							Connect
						</button>
					) : (
						<button
							className='game-btn-wrap-head'
							onClick={(e) => {
								e.preventDefault();
								dispatch(clearCache());
							}}
						>
							Disconnect
						</button>
					)}
					{hideData ? <ShowMessage statedata={hideData} onClosePopup={setHideData} /> : null}

					<div className='centered-box'>
						<div className='slot-width-wrapper'>

							<div className="fullSlot">
								<h1 className="casinoName">Slot Machine Game</h1>
								<div className="balance-wrap">
									<div className="price"><div>Jackpot:</div>{jackpot} Matic</div>
									<div className="spin-counter"><div>Total Spins:</div>{`${totalSpins}`}</div>
								</div>
								<div className="slot">
									<div className="row">
										{row1()}
									</div>
									<div className="row">
										{row2()}
									</div>
									<div className="row">
										{row3()}
									</div>
								</div>
								<h1 className="price full-width">
									{message}{message1}
								</h1>
								<div className="slotFoot">
									<button className="purchase-btn" onClick={(e) => {
										// setLoading(false)
										// e.preventDefault();
										purchaseHandler()
										setModal(true)
										setClosePopUp(true)
									}}>Purchase</button>

									{
										closePopUp ?
											<div className={`pop-up ${modal && 'active'}`}>

												<div className='popup-wrapper'>
													<div className='popup-content pop-up-loader-wrap'>
														<button className="close-popup">

															<i className="cancel-icon" onClick={(e) => {
																// e.preventDefault();
																//  setModal(false)

																onClickPopClose()
															}}></i>
														</button>
														<div className='form-wrap '>
															<div className="form-block">
																<input onChange={inputChangeHandler} type="radio" id="html" name="fav_language" value={"0.1"} />
																<label for="html">0.1 Matic = 12 Spin</label>
															</div>
															<div className="form-block">
																<input onChange={inputChangeHandler} type="radio" id="javascript" name="fav_language" value={"0.2"} />
																<label for="javascript">0.2 Matic = 90 Spin</label>
															</div>
															<button type="submit" className={`form-btn ${loading && "btn-active"}`} onClick={(e) => {
																// setLoading(false)
																// e.preventDefault();
																if (Number(purchaseAmount) > 0) {
																	setLoading(true)
																	deposit(purchaseAmount);
																}
															}}>
																{
																	loading ?
																		(
																			<Loader />
																		)
																		: "Submit"
																}
															</button>
														</div>
													</div>
												</div>

											</div>
											:
											setmodals()
									}
									<button className={`spinButton ${spinsLeft === 0 ? 'disabled' : ''}`} onClick={(e) => {
										// setLoading(false)
										// e.preventDefault();
										setRendomReward(true)
										rendomWords()
										setIsShowTransitionModal(true)
										// calculateReward()
									}}>Spin</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			{isShowTransitionModal ? <TransitionModal  data={open}  progressData={progress}  /> : null}

			
		</>
	)
}

export default Game